import * as watcherSagas from './watcherSagas'

export { CitiesReducer } from './reducers'

export type { CitiesState } from './reducers'

export const citiesSagas = Object.values(watcherSagas)
